import React from 'react'

const Error = () => {
  return (
    <div>
      hello
    </div>
  )
}

export default Error
